import { resetLobbyDetails } from '@/store/slices/lobby-details.slice';
import {
	removeFromStorage,
	getFromStorage,
	collectFingerprint,
	getPublicIpAddress,
	clearExternalUserId,
	clearInviteToken,
} from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
import { clearSession } from '../session.slice';
import { HAS_SESSION_KEY } from '@/constants';

export const signOutAction = createAsyncThunk<void, void>(
	'auth/signOut',
	async (_, { dispatch, getState }: any) => {
		clearExternalUserId();
		clearInviteToken();

		const { access } = getState().session;
		if (access) {
			localStorage.setItem(HAS_SESSION_KEY, 'false');
		}
		const referralCode = getFromStorage();
		if (referralCode) {
			const fingerprint = collectFingerprint();
			const ipAddress = await getPublicIpAddress();
			const { default: referralApi } = await import('@/store/api/referral.api');
			await dispatch(
				referralApi.endpoints.cleanupReferralFingerprint.initiate(
					{ referralCode, fingerprint, ipAddress },
					{ track: false }
				)
			);
			removeFromStorage();
		}
		dispatch(clearSession());
		dispatch(resetLobbyDetails());
		dispatch(api.util.resetApiState());
	}
);
